import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';

import EditIcon from '../images/edit-icon.png';
import DeleteIcon from '../images/delete.png';

const moment = require('moment');

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: { borderRight: '1px solid #ccc' },
};

class ActionsCellRenderer extends Component {
  render() {
    const { data, onEdit, onDelete } = this.props;
    return (
      <div>
        <img
          src={EditIcon}
          alt="Edit"
          style={{ width: 16, height: 16, cursor: 'pointer' }}
          onClick={() => onEdit(data)}
        />{' '}
        <img
          src={DeleteIcon}
          alt="Delete"
          style={{ width: 14, height: 14, cursor: 'pointer' }}
          onClick={() => onDelete(data)}
        />
      </div>
    );
  }
}

export class TroubleTicketActionTableDefault extends Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.gridColumnApi = null;

    this.onGridReady = this.onGridReady.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.autoSizeUnspecifiedColumns = this.autoSizeUnspecifiedColumns.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns();
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll('.ag-header-cell-text');
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      gridApi.setHeaderHeight(maxHeight + 10);
    });
  };

  autoSizeUnspecifiedColumns = () => {
    if (!this.gridColumnApi) return;
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  render() {
    const { actionList, onEdit, onDelete, onDoubleClick } = this.props;

    const columnDefs = [
      {
        headerName: 'Date',
        field: 'actionDateTime',
        width: 140,
        valueFormatter: (params) =>
          params.value ? moment(params.value).format('MM/DD/YYYY h:mm A') : '',
      },
      {
        headerName: 'By',
        field: 'actionByLastName',
        width: 110,
        valueGetter: (params) => {
          const fn = params.data?.actionByFirstName || '';
          const ln = params.data?.actionByLastName || '';
          return fn ? `${fn} ${ln}`.trim() : '';
        },
      },
      { headerName: 'Status', field: 'actionStatus', width: 80 },
      {
        headerName: 'Description',
        field: 'actionDescription',
        flex: 1,
        tooltipField: 'actionDescription',
      },
      {
        headerName: 'Next Steps',
        field: 'nextSteps',
        flex: 1,
        tooltipField: 'nextSteps',
      },
      {
        headerName: '',
        field: 'editDelete',
        width: 60,
        sortable: false,
        filter: false,
        resizable: false,
        cellRenderer: ActionsCellRenderer,
        cellRendererParams: { onEdit, onDelete },
      },
    ];

    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs,
      rowData: actionList,
      animateRows: true,
      defaultColDef,
      rowHeight: 20,
      headerHeight: 25,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: onDoubleClick,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{ width: '100%', height: '150px', marginTop: '4px' }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}
